import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { createSelector } from 'reselect';
import { getBundleParams, getBundlesUrl, isEmpty, locationsKeyMapper } from "../../Helpers/bundle";
var locationMappingSelector = createSelector(function (state, config) {
  return {
    itemElements: state.cxeBundles.elements,
    config: config
  };
}, function (_ref) {
  var itemElements = _ref.itemElements,
    config = _ref.config;
  if (!itemElements || !config) {
    return false;
  }
  var mappedObject;
  var locationMapping = config.get('locationMapping');
  var NAME_SUFFIX = '_name';
  var clearNameSuffix = function clearNameSuffix(value) {
    return value.split(NAME_SUFFIX)[0];
  };
  var containsSuffix = function containsSuffix(value, suffix) {
    return value.indexOf(suffix, value.length - suffix.length) !== -1;
  };
  var levelValuesMapper = function levelValuesMapper(locationsResolved) {
    return Object.keys(locationsResolved).reduce(function (previousObj, currentElm) {
      if (containsSuffix(currentElm, NAME_SUFFIX)) {
        var key = clearNameSuffix(currentElm);
        var value = locationsResolved[currentElm];
        var selectedKey = locationMapping ? locationsKeyMapper(key, locationMapping) : key;
        return Object.assign(Object.assign({}, previousObj), _defineProperty({}, selectedKey, value));
      }
      return previousObj;
    }, {});
  };
  var mappedElementsLocations = function mappedElementsLocations(elements) {
    return Object.keys(elements).reduce(function (previousElm, currentElm) {
      var elmLocation = elements[currentElm];
      var elmLocationResolved = elmLocation.locations_resolved;
      if (!isEmpty(elmLocationResolved)) {
        mappedObject = levelValuesMapper(elmLocationResolved);
        var levelsValues = Object.keys(mappedObject).map(function (level) {
          return mappedObject[level];
        });
        levelsValues.reverse();
        var prioritizedLevels = levelsValues;
        var mappingPrioritized = Object.assign(Object.assign({}, mappedObject), {
          prioritizedLevels: prioritizedLevels
        });
        return Object.assign(Object.assign({}, previousElm), _defineProperty({}, currentElm, mappingPrioritized));
      }
      return previousElm;
    }, {});
  };
  return mappedElementsLocations(itemElements);
});
export var bundleStatus = createSelector(function (state, url) {
  return state.cxeBundles && state.cxeBundles.collections && state.cxeBundles.collections[url] && state.cxeBundles.collections[url].isError;
}, function (state, url) {
  return state.cxeBundles && state.cxeBundles.collections && state.cxeBundles.collections[url] && state.cxeBundles.collections[url].isFetching;
}, function (state, url) {
  return state.cxeBundles && state.cxeBundles.collections && state.cxeBundles.collections[url] && state.cxeBundles.collections[url].hasData;
}, function (isError, isFetching, hasData) {
  return {
    isError: isError,
    isFetching: isFetching,
    hasData: hasData
  };
});
var getBundleCollectionUrlElements = createSelector(function (state, reqProps) {
  var params = getBundleParams(reqProps, state);
  var bundleUrl = getBundlesUrl(state, reqProps.url, params);
  return bundleUrl;
}, function (state) {
  return state.cxeBundles && state.cxeBundles.collections;
}, function (state) {
  return state.cxeBundles && state.cxeBundles.elements;
}, function (url, collections, elements) {
  return {
    url: url,
    collections: collections,
    elements: elements
  };
});
export var bundlesSelector = createSelector(function (state, reqProps) {
  var bundleCollectionUrl = getBundleCollectionUrlElements(state, reqProps);
  return bundleCollectionUrl;
}, function (state, _, config) {
  return locationMappingSelector(state, config);
}, function (_ref2, resolvedLocations) {
  var url = _ref2.url,
    collections = _ref2.collections,
    elements = _ref2.elements;
  var bundles = {};
  if (collections && collections[url]) {
    collections[url].items.reduce(function (bundles, itemId) {
      bundles[itemId] = Object.assign(Object.assign({}, elements[itemId]), {
        locations_resolved: resolvedLocations[itemId]
      });
      return bundles;
    }, bundles);
  }
  return bundles;
});
export var isError = createSelector(function (state, reqProps) {
  var bundleCollectionUrl = getBundleCollectionUrlElements(state, reqProps);
  return bundleCollectionUrl;
}, function (_ref3) {
  var url = _ref3.url,
    collections = _ref3.collections;
  if (collections && collections[url]) {
    return collections[url].isError;
  }
  return false;
});
export var isFetching = createSelector(function (state, reqProps) {
  var bundleCollectionUrl = getBundleCollectionUrlElements(state, reqProps);
  return bundleCollectionUrl;
}, function (_ref4) {
  var url = _ref4.url,
    collections = _ref4.collections;
  if (collections && collections[url]) {
    return collections[url].isFetching;
  }
  return false;
});